module.exports = __webpack_public_path__ + "static/assets/37954fe300d44f8765b6d48b2836fcf5.png";